<template>
  <v-list-group v-if="item.authorized" :group="group" :sub-group="subGroup">
    <template v-if="expandOnHover && !hovered" v-slot:prependIcon>
      <v-list-item-icon v-if="item.icon" :class="!expandOnHover || hovered ? 'ml-2' : ''" class="sicon">
        <v-icon :color="$route.fullPath != item.to ? 'side_bar_icon' : 'side_bar_active_icon'" class="sicon"> mdi-{{ item.icon }} </v-icon>
      </v-list-item-icon>
    </template>

    <template v-slot:activator>
      <v-list-item-icon v-if="item.icon" :class="!expandOnHover || hovered ? 'ml-2' : ''" class="sicon">
        <v-icon :color="$route.fullPath != item.to ? 'side_bar_icon' : 'side_bar_active_icon'" class="sicon"> mdi-{{ item.icon }} </v-icon>
      </v-list-item-icon>

      <v-list-item-content v-if="item.title" :class="!expandOnHover || hovered ? 'ml-2' : ''">
        <v-list-item-title
          :class="$route.fullPath == item.to ? 'side_bar_active_text--text' : 'side_bar_text--text'"
          class="custom-list-font"
          v-text="item.title"
        />
      </v-list-item-content>
    </template>
    <template v-for="(child, i) in children">
      <BaseItemSubGroup
        v-if="child.authorized && child.children"
        :key="`sub-group-${i}`"
        :item="child"
        class="second-dd pl-6"
        :expandOnHover="expandOnHover"
        :hovered="hovered"
      />
      <BaseItem v-else-if="child.authorized" class="pl-6" :key="`item-${i}`" :item="child" text :expandOnHover="expandOnHover" :hovered="hovered" />
    </template>
  </v-list-group>
</template>

<script>
// Utilities
import kebabCase from "lodash/kebabCase";
import { mapState, mapActions } from "vuex";

export default {
  name: "BaseItemGroup",

  inheritAttrs: false,

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
    hovered: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: [],
      }),
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
  },

  async created() {
    await this.checkMenuRole(this.item.role).then((response) => {
      this.$set(this.item, "authorized", response);
    });
    for await (let child of this.item.children) {
      this.checkMenuRole(child.role).then((response) => {
        this.$set(child, "authorized", response);
      });
    }
  },

  computed: {
    ...mapState("auth", ["userRoleList"]),
    children() {
      return this.item.children.map((item) => ({
        ...item,
        to: !item.to ? undefined : `${this.item.group}/${item.to}`,
      }));
    },
    group() {
      return this.genGroup(this.item.children);
    },
  },

  methods: {
    ...mapActions("auth", ["checkMenuRole"]),
    genGroup(children) {
      return children
        .filter((item) => item.to)
        .map((item) => {
          const parent = item.group || this.item.group;
          let group = `${parent}/${kebabCase(item.to)}`;

          if (item.children) {
            group = `${group}|${this.genGroup(item.children)}`;
          }

          return group;
        })
        .join("|");
    },
  },
};
</script>

<style scoped>
.custom-list-font {
  font-size: 17px;
  line-height: 1.5em;
  font-family: "Roboto", sans-serif;
}

.customDivider {
  padding: 0px 2px;
  position: absolute !important;
  left: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.v-application--is-ltr #main-sidebar .v-list-group .v-list-group__items > .v-list-item .v-icon,
.v-application--is-ltr #main-sidebar .v-list-group .sicon {
  font-size: 18px;
  margin: auto;
  visibility: visible !important;
}
</style>
